import { render, staticRenderFns } from "./ModalDispatchFrame.vue?vue&type=template&id=15ca08cb&scoped=true&"
import script from "./ModalDispatchFrame.vue?vue&type=script&lang=js&"
export * from "./ModalDispatchFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalDispatchFrame.vue?vue&type=style&index=0&id=15ca08cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca08cb",
  null
  
)

export default component.exports